var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193 121",
    width: 500,
    height: 313,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #002d53;stroke: #000000;stroke-width: 3 } \n\t\t.s2 { fill: none;stroke: #000000;stroke-miterlimit:10;stroke-width: 3 } \n\t\t.s3 { fill: #2a6ada } \n\t\t.s4 { fill: #000000 } \n\t\t.s5 { mix-blend-mode: multiply;fill: #c6c6c6 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m96.8 16.8c-43.1 0-80 21.2-94.6 51 14.6 29.8 51.5 51 94.6 51 43.1 0 80-21.2 94.6-51-14.6-29.8-51.5-51-94.6-51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m48.9 67.8c0-26.4 21.5-47.9 47.9-47.9 26.5 0 47.9 21.5 47.9 47.9 0 26.5-21.4 47.9-47.9 47.9-26.4 0-47.9-21.4-47.9-47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m96.8 16.8c-43.1 0-80 21.2-94.6 51 14.6 29.8 51.5 51 94.6 51 43.1 0 80-21.2 94.6-51-14.6-29.8-51.5-51-94.6-51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m143.5 25.8c-13.1-4-26-7.2-41.1-6.5-43.1 2-80.7 27.8-93.9 58.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m129.9 68.1c0 18.6-15.1 33.6-33.6 33.6-18.6 0-33.7-15-33.7-33.6 0-18.6 15.1-33.6 33.7-33.6 18.5 0 33.6 15 33.6 33.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m113 68.1c0 9.2-7.5 16.8-16.7 16.8-9.3 0-16.8-7.6-16.8-16.8 0-9.3 7.5-16.8 16.8-16.8 9.2 0 16.7 7.5 16.7 16.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m133.4 28.3l-2.3-11.1 16.9-16.9 2.3 11.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m135.7 30.6l11.1 2.3 16.9-16.9-11.1-2.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m98.1 69.1c-0.9 0.9-2.3 0.9-3.2 0-0.9-0.9-0.9-2.3 0-3.2l57.9-57.8c0.9-0.9 2.3-0.9 3.1 0 0.9 0.8 0.9 2.3 0 3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m146.3 65.1h-49.7c-1.2 0-2.2 1-2.2 2.2 0 1.3 1 2.3 2.2 2.3h48.9q0.2-2.3 0.8-4.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMision);
export default __webpack_public_path__ + "static/media/mision.e4dafb118a13b86590a66738ef9efcec.svg";
export { ForwardRef as ReactComponent };